import { ApiError, errorMessage } from '@lumora/bridge';

export const resizeImage = (file: File, maxSize: number = 1440): Promise<Blob | null> => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            let { width, height } = img;
            if (width > maxSize || height > maxSize) {
                if (width > height) {
                    height = Math.round((height * maxSize) / width);
                    width = maxSize;
                } else {
                    width = Math.round((width * maxSize) / height);
                    height = maxSize;
                }
            }
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) return resolve(file);

            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => resolve(blob), file.type, 0.9);
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });
};

/** Resized blob, or the original file when the browser cannot decode/encode it. */
export async function prepareUploadBlob(
    file: File,
    maxSize: number,
    resizeFn: (f: File, max: number) => Promise<Blob | null> = resizeImage,
): Promise<Blob> {
    try {
        const out = await resizeFn(file, maxSize);
        return out ?? file;
    } catch {
        return file;
    }
}

export function uploadErrorMessage(err: unknown): string {
    if (err instanceof ApiError) {
        switch (err.code) {
            case 'upload_cap_exceeded':
                return 'Monthly upload limit reached. Contact support.';
            case 'rate_limited':
                return 'Too many uploads at once. Wait a minute and try again.';
            case 'upload_too_large':
                return 'A photo is too large (max 10 MB).';
            default:
                return err.message || 'Upload failed.';
        }
    }
    return errorMessage(err, 'Upload failed.');
}
